<template>
	<div>
		<div class="mask" v-show="active"></div>
		<div class="parent" v-show="active">
			<div class="mod scroll">
				<div class="mod-head">
					<h1 class="text-center fz16"></h1>
					<i class="fa fa-times pull-right" @click="close"></i>
				</div>
				<div class="mod-body" v-html="dbody">
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data (){
			return {
				active : false,
				dbody : ''
			}
		},
		mounted (){
			this.$bdDialog.add(this);
		},
		methods : {
			close (){
				this.active = false;
			},
			init (html){
				this.dbody = html;
			}
		}
	}
</script>
<style scoped>
	.mask{position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: #000;opacity: .3;z-index: 10002;transform: translate3d(0,0,0);}
	.parent{padding: .3rem .7rem;position: fixed;left: 0;top: 0;z-index: 10003;width: 100%;height: 100%;}
	.parent>.mod{height: 100%;position: relative;}
	.parent>.mod>.mod-head{position: absolute;left: 0;top: 0;width: 100%;background: #fff;height: .4rem;z-index: 9;}
	.parent>.mod>.mod-body{width: 100%;height: 100%;background: #fff;padding: .4rem .15rem .15rem .15rem;position: relative;overflow: auto;}
	.parent>.mod>.mod-head i.fa-times{font-size: 30px;margin-right: 5px;padding: .1rem;position: absolute;right: 0;top: 0;z-index: 9;}
</style>



// WEBPACK FOOTER //
// template.vue?7cf4fe90